import moment from 'moment';
import numeral from 'numeral';

export const Ymd = unix => {
    return moment.unix(unix / 1000).format('YYYY.MM.DD');
};

export const YmdHi = unix => {
    return moment.unix(unix / 1000).format('YYYY.MM.DD HH:mm');
};

export const YmdHis = unix => {
    return moment.unix(unix / 1000).format('YYYY.MM.DD HH:mm:ss');
};

export const isDate = str => {
    return str === moment(str, 'YYYY.MM.DD').format('YYYY.MM.DD');
};

export const dayDiff = (str1, str2) => {
    return moment(str2, 'YYYY.MM.DD').diff(moment(str1, 'YYYY.MM.DD'));
};

export const Num = num => {
    if (num === '-') {
        return num;
    }
    return numeral(num).format('0,0');
};
